/* eslint-disable */
import {
  ICalendarItem,
  useDictionary,
} from "../../shared";
import React from "react";
import { useIntl } from 'react-intl';
import type { FC } from "react";
import messages from "./messages";
import { CalendarBASF } from "../CalendarBASF";
import { CalendarBASFPropsType } from "../CalendarBASF/types";
import { dictionaryService } from "../../dataFlow";
import { DictionaryItem } from "@sa/rep-mdm";

export const CalendarYear: FC<CalendarBASFPropsType & { allYear?: boolean; lastYear?: unknown; firstYear?: unknown }> = (props) => {
  const intl = useIntl();
  const { items: itemsProps, label, hasData, lastYear, firstYear, allYear } = props;
  const [items, setItems] = React.useState<ICalendarItem[]>();

  const [dictItems] = useDictionary(dictionaryService, itemsProps ? undefined : props.dictionary);
  React.useEffect(() => {
    let itemsSource = (itemsProps || dictItems) as DictionaryItem[] | null;
    if (itemsSource) {
      if (hasData) {
        itemsSource = itemsSource.filter((x) => x.getSingleValue<boolean>("hasData") === true);
      }
      let nextItems = itemsSource
        .map<ICalendarItem>((x) => ({
          id: x.id.toString(),
          name: x.getValue<string | number>("name")?.toString() || "",
          parent: x.getValue<string | number>("parent")?.toString() || "",
          frequency: `${x.getValue<string | number>("frequencyId")}`?.toString() || "",
        }))
        .filter((item) => item.frequency === "1");

      if (!allYear) {
        let filterMaxYear = Number(lastYear);
        let filterMinYear = Number(firstYear);
        if (!filterMaxYear) {
          const now = new Date();
          const isJanuary = now.getMonth() === 0;
          const isFebruary = now.getMonth() === 1;
          const isMarch = now.getMonth() === 2;
          const isFirstQuartal = isJanuary || isFebruary || isMarch;
          const year = new Date().getFullYear();
          filterMaxYear = Number(`1${year - (isFirstQuartal ? 2 : 1)}0101`);
        }
        nextItems = nextItems.filter((item) => {
          const itemId = Number(item.id);
          return itemId <= filterMaxYear && (!filterMinYear || itemId >= filterMinYear);
        });
      }

      setItems(nextItems);
    }
  }, [dictItems, itemsProps, lastYear]);

  const fillBlanks = React.useMemo(() => (id: string) => id.substr(1, 4), []);
  return React.useMemo(() => {
    return (
      <CalendarBASF
        value={props.value}
        label={label || intl.formatMessage(messages.title)}
        fillBlanks={fillBlanks}
        {...props}
        items={items}
      />
    );
  }, [items, label, fillBlanks, props.value]);
};
